"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HoverPopover = exports.Popover = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("@tippyjs/react"));
require("tippy.js/dist/tippy.css");
require("./Popover.css");
var classnames_1 = __importDefault(require("classnames"));
var css_1 = require("@emotion/css");
var Popover = function (_a) {
  var wrap = _a.wrapperProps,
    className = _a.className,
    children = _a.children,
    shown = _a.shown,
    customColor = _a.customColor,
    _b = _a.placement,
    placement = _b === void 0 ? "bottom" : _b,
    _c = _a.animation,
    animation = _c === void 0 ? "none" : _c,
    _d = _a.duration,
    duration = _d === void 0 ? [0, 0] : _d,
    _e = _a.arrow,
    arrow = _e === void 0 ? true : _e,
    _f = _a.interactive,
    interactive = _f === void 0 ? true : _f,
    _g = _a.maxWidth,
    maxWidth = _g === void 0 ? "340px" : _g,
    _h = _a.trigger,
    trigger = _h === void 0 ? "manual" : _h,
    offset = _a.offset,
    _j = _a.color,
    color = _j === void 0 ? "success" : _j,
    distance = _a.distance,
    cs = _a.contentStyle,
    _k = _a.tooltip,
    tooltip = _k === void 0 ? false : _k,
    animate = _a.animate,
    unstyle = _a.unstyle,
    _l = _a.zIndex,
    zIndex = _l === void 0 ? 9999999999 : _l,
    restProps = __rest(_a, ["wrapperProps", "className", "children", "shown", "customColor", "placement", "animation", "duration", "arrow", "interactive", "maxWidth", "trigger", "offset", "color", "distance", "contentStyle", "tooltip", "animate", "unstyle", "zIndex"]);
  var extraClass = (0, css_1.css)({
    "&& .tippy-content": __assign({}, cs)
  });
  var colorClass = "";
  if (customColor) {
    colorClass = (0, css_1.css)("--vsx-popover-colored-border-color: ".concat(customColor));
  } else if (color) {
    colorClass = "vsx-popover-".concat(color);
  }
  return (0, jsx_runtime_1.jsx)("div", __assign({}, wrap, {
    className: (0, classnames_1.default)("vsx-popover-wrapper", wrap === null || wrap === void 0 ? void 0 : wrap.className)
  }, {
    children: (0, jsx_runtime_1.jsx)(react_1.default, __assign({}, restProps, {
      zIndex: zIndex,
      className: (0, classnames_1.default)("vsx-popover", unstyle && "vsx-popover-unstyled", tooltip && "vsx-tooltip", colorClass, className, extraClass, animate && "vsx-popover-animate"),
      placement: placement,
      animation: animation,
      duration: duration,
      arrow: arrow,
      visible: shown,
      interactive: interactive,
      trigger: shown === undefined ? trigger : undefined,
      maxWidth: maxWidth,
      offset: [offset !== null && offset !== void 0 ? offset : 0, distance !== null && distance !== void 0 ? distance : 10]
    }, {
      children: (0, jsx_runtime_1.jsx)("div", __assign({
        className: "vsx-popover-reference"
      }, {
        children: children
      }))
    }))
  }));
};
exports.Popover = Popover;
var HoverPopover = function (_a) {
  var children = _a.children,
    restProps = __rest(_a, ["children"]);
  return (0, jsx_runtime_1.jsx)(exports.Popover, __assign({}, restProps, {
    trigger: "mouseenter"
  }, {
    children: children
  }));
};
exports.HoverPopover = HoverPopover;